/**
 * Card Component
 *
 * Reusable card container with consistent styling.
 * Replaces repeated `bg-white rounded-lg shadow-sm border border-gray-200 p-6` pattern.
 *
 * @component
 * @param {Object} props
 * @param {React.ReactNode} props.children - Card content
 * @param {string} [props.className] - Additional classes to merge
 * @param {string} [props.padding] - Override padding (default: 'p-6')
 * @param {object} [props.rest] - Passed through to the wrapper div
 */
import PropTypes from 'prop-types';

export default function Card({ children, className = '', padding = 'p-6', ...rest }) {
  return (
    <div
      className={`bg-white rounded-lg shadow-sm border border-gray-200 ${padding} ${className}`.trim()}
      {...rest}
    >
      {children}
    </div>
  );
}

Card.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  padding: PropTypes.string,
};
